import { AppState } from '../reducers/app.reducer';
import { createSelector } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';

const selectRouter = (state: AppState) => state.router;

export const selectUrl = createSelector(selectRouter, (state: RouterReducerState) => (state ? state.state.url : ''));
